module.exports = __webpack_public_path__ + "static/media/Cryptocape9.23df71f9.png";


//////////////////
// WEBPACK FOOTER
// ./client/src/img/Cryptocape9.png
// module id = 585
// module chunks = 0